/* eslint-disable import/prefer-default-export */
import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

const { init } = createAllActions(types.SCOPE);

const setMode = mode => ({
  type: types.SET_MODE,
  mode,
});

const setSort = sort => ({
  type: types.SET_SORT,
  sort,
});

const setEnablePartnerModalVisibility = visible => ({
  type: types.CHANGE_ENABLE_PARTNER_MODAL_VISIBILITY,
  visible,
});

export {
  init,
  setMode,
  setSort,
  setEnablePartnerModalVisibility,
};
